<template>
  <li class="md-subheader" :class="[themeClass]" v-if="$parent.$options._componentTag === 'md-list'">
    <slot></slot>
  </li>

  <div class="md-subheader" :class="[themeClass]" v-else>
    <slot></slot>
  </div>
</template>

<style lang="scss" src="./mdSubheader.scss"></style>

<script>
  import theme from '../../core/components/mdTheme/mixin';

  export default {
    mixins: [theme]
  };
</script>



// WEBPACK FOOTER //
// mdSubheader.vue?8719faca